import { Box, Heading, Text } from "@vinomofo/components";

import React from "react";
import { TimerDisplay } from "../components/inline-countdown-timer/TimerDisplay";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import styled from "styled-components";

dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(customParseFormat);

const BaseText = styled(Text)`
  color: white;
  font-size: 16px;
  font-weight: 500;
  font-family: "DM Sans";
  font-style: normal;
  line-height: 132%;
  letter-spacing: 1%;
  text-align: right;
`;

const MobileText = styled(BaseText)`
  display: block;
  @media ${({ theme }) => theme.mq.min.tablet} {
    display: none;
  }
`;

const DesktopText = styled(BaseText)`
  display: none;
  @media ${({ theme }) => theme.mq.min.tablet} {
    display: block;
  }
`;

const test = ({ __typename }: { __typename: string }): boolean =>
  __typename === "VinoData_EventCountdown";

const create = (data: {
  title: string;
  startDate: string;
  layout?: string;
}): JSX.Element => {
  const { startDate, title, layout } = data;

  if (!startDate) {
    return <></>;
  }

  const targetDate = dayjs(startDate);

  const calculateTimeLeft = () => {
    const now = dayjs();
    const end = dayjs(targetDate);
    const diff = end.diff(now);

    if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, diff };

    const dur = dayjs.duration(diff);
    return {
      days: Math.floor(dur.asDays()),
      hours: dur.hours(),
      minutes: dur.minutes(),
      seconds: dur.seconds(),
      diff,
    };
  };

  const [timeLeft, setTimeLeft] = React.useState(calculateTimeLeft());

  React.useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    // Cleanup on unmount
    return () => clearInterval(timer);
  }, [targetDate]);

  if (layout === "My Deals") {
    return (
      <Box
        justifyContent={["right"]}
        display="flex"
        alignContent={["right"]}
        paddingTop={[10, 20, 30]}
        paddingBottom={[0]}
        gridGap={[10]}
        marginBottom={["-50px", "-20px", "-25px"]}
        marginTop={["20px", "auto", "auto"]}
      >
        {timeLeft.diff > 0 ? (
          <Box
            justifyContent={["right"]}
            display="flex"
            flexDirection="row"
            alignItems="center"
            alignContent={["right"]}
            textAlign={["right"]}
            gridGap={2}
          >
            <MobileText>NEXT DROP:</MobileText>
            <DesktopText>NEXT DEAL DROPS IN:</DesktopText>
            <Box minWidth="100px" display="flex">
              <Text
                color="#F3B659"
                fontSize={16}
                fontWeight={500}
                fontFamily="DM Sans"
                fontStyle="normal"
                lineHeight="132%"
                letterSpacing="1%"
                textAlign="right"
              >
                {String(timeLeft.days).padStart(2, "0")}:{" "}
                {String(timeLeft.hours).padStart(2, "0")}:{" "}
                {String(timeLeft.minutes).padStart(2, "0")}:{" "}
                {String(timeLeft.seconds).padStart(2, "0")}
              </Text>
            </Box>
          </Box>
        ) : (
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            alignContent={["right"]}
            textAlign={["right"]}
            gridGap={2}
          >
            <Text color="white" fontSize={[16]} fontWeight={500}>
              NEXT DEAL COMING SOON...
            </Text>
          </Box>
        )}
      </Box>
    );
  }

  return (
    <Box
      justifyContent={"center"}
      display="flex"
      alignContent={"center"}
      paddingTop={[250, 500, 750]}
      paddingBottom={[20, 80, 160]}
      gridGap={[20]}
    >
      {timeLeft.diff > 0 ? (
        <TimerDisplay dateTime={startDate} isExpandedDisplay={true} />
      ) : (
        <Box
          justifyContent={"center"}
          display="flex"
          flexDirection="column"
          alignContent={"center"}
          paddingTop={[10]}
          paddingBottom={[10]}
        >
          <Heading
            fontFamily="TIMMONSNY"
            color="white"
            textAlign="center"
            fontWeight={100}
            fontSize={100}
            letterSpacing={"normal"}
          >
            EVENT ENDED!
          </Heading>
        </Box>
      )}
    </Box>
  );
};

export default { test, create };
